import dayjs from "dayjs";

export function formatMissingDatesPreview(dates, max = 10) {
  if (!dates?.length) return null;

  const shown = dates.slice(0, max);
  const formatted = shown.map((d) => dayjs(d).format("MMM D"));
  const remaining = dates.length - shown.length;

  if (remaining > 0) {
    return `${formatted.join(", ")} +${remaining} more`;
  }
  return formatted.join(", ");
}

export function formatDateRangeLabel(from, to) {
  const fromD = dayjs(from);
  const toD = dayjs(to);
  if (fromD.isSame(toD, "day")) {
    return fromD.format("MMM D, YYYY");
  }
  if (fromD.isSame(toD, "month") && fromD.isSame(toD, "year")) {
    return `${fromD.format("MMM D")}–${toD.format("D, YYYY")}`;
  }
  return `${fromD.format("MMM D, YYYY")}–${toD.format("MMM D, YYYY")}`;
}

export function getTimeReportingStatusLabel(status) {
  switch (status) {
    case "complete":
      return "Complete";
    case "gaps":
      return "Gaps";
    case "no_reports":
      return "No reports";
    default:
      return status;
  }
}

export function getTimeReportingStatusClass(status) {
  switch (status) {
    case "complete":
      return "bg-green-100 text-green-800";
    case "gaps":
      return "bg-amber-100 text-amber-800";
    case "no_reports":
      return "bg-red-100 text-red-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
}

export function formatFlexHours(hours) {
  if (hours == null || Number.isNaN(Number(hours))) return "—";
  const value = Math.round(Number(hours) * 10) / 10;
  if (value === 0) return "0h";
  const sign = value > 0 ? "+" : "−";
  return `${sign}${Math.abs(value).toFixed(1)}h`;
}

export function getFlexHoursClass(hours) {
  if (hours > 0) return "text-green-700 font-medium";
  if (hours < 0) return "text-red-700 font-medium";
  return "text-gray-500";
}
